import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CreatePhysicalProductRequest } from '../common/model/dto/physical-product/create-physical-product-request';
import { UpdatePhysicalProductRequest } from '../common/model/dto/physical-product/update-physical-product-request';
import {
  createPhysicalProduct,
  deletePhysicalProduct,
  updatePhysicalProduct,
} from '../services/admin/admin-physical-product.service';

export function useAdminPhysicalProductMutations() {
  const qc = useQueryClient();

  const invalidateList = () =>
    qc.invalidateQueries({ queryKey: ['admin-physical-products'] });

  const createProduct = useMutation({
    mutationFn: (request: CreatePhysicalProductRequest) =>
      createPhysicalProduct(request),
    onSuccess: invalidateList,
  });

  const updateProduct = useMutation({
    mutationFn: ({
      id,
      request,
    }: {
      id: string;
      request: UpdatePhysicalProductRequest;
    }) => updatePhysicalProduct(id, request),
    onSuccess: (_, { id }) => {
      qc.invalidateQueries({ queryKey: ['admin-physical-product', id] });
      invalidateList();
    },
  });

  const deleteProduct = useMutation({
    mutationFn: (id: string) => deletePhysicalProduct(id),
    onSuccess: (_, id) => {
      qc.removeQueries({ queryKey: ['admin-physical-product', id] });
      invalidateList();
    },
  });

  return { createProduct, updateProduct, deleteProduct };
}
